import { IEvent } from "@Interfaces";
import { isEmpty } from "@Utils";
import { ICreatorFAQ } from "../Interfaces";

export const getCreatorFAQProps = ({
    eventData,
}: {
    eventData: IEvent.IEventData;
}): ICreatorFAQ.IProps => {
    const faqs = eventData?.faqs || [];
    return {
        hideComponent: isEmpty(faqs),
        faqs,
    };
};
